module.exports = __webpack_public_path__ + "1d5bd07c1f8bb73d0a7c73518d702096.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/none.svg
// module id = 144
// module chunks = 0